__turbopack_context__.v({
  "errorPageBody": "ErrorPage-module-scss-module__kpSJLG__errorPageBody",
  "errorPageContent": "ErrorPage-module-scss-module__kpSJLG__errorPageContent",
  "errorPageDescription": "ErrorPage-module-scss-module__kpSJLG__errorPageDescription",
  "errorPageImage": "ErrorPage-module-scss-module__kpSJLG__errorPageImage",
  "errorPageTitle": "ErrorPage-module-scss-module__kpSJLG__errorPageTitle",
});
